<template>
  <div>
    <v-container>
      <div class="flex flex-col space-y-2.5 ">
        <div class="flex items-center ">
          <div class="flex space-x-2.5 items-start" style="height: 100%;">
            <export-expense />
          </div>
        </div>
        <v-divider></v-divider>
        <div>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header class="white--text"
                :color="expenseCategoryEditMode ? 'yellow darken-3' : 'primary'"><span>Input
                  Forms</span></v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="flex flex-col space-y-2.5">
                  <div class="flex space-x-2.5">
                    <div class="space-y-2.5">
                      <div class="pt-2" v-if="authPermissions.has('expense_categories:create')">
                        <h3 class="text-uppercase">Create Category</h3>
                        <create-expense-category :edit.sync="editExpenseCategory"></create-expense-category>
                      </div>
                      <v-divider></v-divider>
                      <div v-if="authPermissions.has('expense_categories:view')">
                        <table-expense-category v-model="editExpenseCategory"></table-expense-category>
                      </div>
                    </div>
                    <v-divider vertical></v-divider>
                    <div class="pa-2 flex flex-col space-y-2.5" v-if="authPermissions.has('expenses:create')">
                      <div>
                        <h2 class="pb-2">New Expense</h2>
                        <create-expense></create-expense>
                      </div>
                      <v-divider></v-divider>
                      <div>
                        <temp-expense></temp-expense>
                        <v-btn color="primary" :disabled="!expenseTempList.length" dense="dense"
                          :loading="expensePosting" @click="storeExpense"><span>Store</span></v-btn>
                      </div>
                    </div>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <v-divider></v-divider>
        <div v-if="authPermissions.has('expenses:view')">
          <v-toolbar color="primary" dense="dense" dark="dark" elevation="0" rounded><span>List</span></v-toolbar>
          <table-expense></table-expense>
        </div>
      </div>
    </v-container>
  </div>
</template>
<script>
import expenseRepository from '@/repositories/expense.repository'
import VueRequestHandler from '@/classes/VueRequestHandler.class'
import requestVars from '@/extra-functions/request-vars.extra'
import { mapGetters, mapActions, mapState } from 'vuex'

const [expensePostVars, expensePostVarNames] = requestVars({ identifier: 'expense', request: 'post', hasData: false })
const expensePostHandler = new VueRequestHandler(null, expensePostVarNames, {})

export default {
  name: 'Expenses',
  components: {
    createExpense: () => import('@/views/dashboard/components/expenses/Create'),
    tableExpense: () => import('@/views/dashboard/components/expenses/Table'),
    tempExpense: () => import('@/views/dashboard/components/expenses/TempTable'),
    createExpenseCategory: () => import('@/views/dashboard/components/expenses/categories/Create'),
    tableExpenseCategory: () => import('@/views/dashboard/components/expenses/categories/Table'),
    exportExpense: () => import('@/views/dashboard/components/expenses/Export'),
  },
  data: () => ({
    editExpenseCategory: {},
    ...expensePostVars,
  }),
  computed: {
    expenseCategoryEditMode() {
      return !this.$objectEmpty(this.editExpenseCategory)
    },
    ...mapState({
      authPermissions: state => state.auth.userPermissions,
    }),
    ...mapGetters({
      expenseTempList: 'expense/getDataToSend',
    }),
  },
  methods: {
    ...mapActions({
      clearExpenseTempList: 'expense/clearListItems',
    }),
    storeExpense() {
      const handler = expensePostHandler
      const repository = expenseRepository.store
      const params = { many: true }
      const data = this.expenseTempList
      handler.setVue(this)
      handler.execute(repository, [{ data }, params], this.storeExpenseStatusOk)
    },
    storeExpenseStatusOk() {
      this.clearExpenseTempList()
    },
  },
}
</script>
